(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centric-athlete-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('centric-athlete-reviews')) {
  customElements.define('centric-athlete-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.track = this.querySelector('.cc__track');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.motion = this.querySelector('.cc__motion');
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.videos = [...this.querySelectorAll('video')];
      const listen = (el, event, fn) => el.addEventListener(event, fn, {signal:this.abort.signal});
      this.dots = this.cards.map((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'cc__dot';
        dot.setAttribute('aria-label', `${i + 1} / ${this.cards.length}`);
        listen(dot, 'click', () => this.go(i, true));
        this.querySelector('.cc__dots').append(dot);
        return dot;
      });
      listen(this.previous, 'click', () => this.go(this.index() - 1, true));
      listen(this.next, 'click', () => this.go(this.index() + 1, true));
      listen(this.track, 'scroll', () => {cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update());});
      listen(this.track, 'keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.go(this.index() + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      listen(this.motion, 'click', () => {this.paused = !this.paused; this.update(); this.syncVideos();});
      listen(document, 'visibilitychange', () => this.syncVideos());
      listen(this.reduced, 'change', () => {if(this.reduced.matches) this.paused = true; this.update(); this.syncVideos();});
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.ccVisible = entry.isIntersecting && entry.intersectionRatio >= .5;
        });
        this.syncVideos();
      }, {threshold:[0,.5,1]});
      this.videos.forEach(video => {video.muted = true; video.playsInline = true; this.videoObserver.observe(video);});
      this.motion.hidden = this.videos.length === 0;
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      listen(document, 'shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
        if (card) {this.go(this.cards.indexOf(card), false); this.paused = true; this.update(); this.syncVideos();}
      });
      requestAnimationFrame(() => {
        const start = this.mobile.matches ? Math.min(Number(this.dataset.mobileStart) || 0, this.cards.length - 1) : 0;
        this.go(start, false);
      });
      this.update();
    }
    index() {
      const left = this.track.getBoundingClientRect().left;
      let index = 0, distance = Infinity;
      this.cards.forEach((card, i) => {const gap = Math.abs(card.getBoundingClientRect().left - left); if (gap < distance) {index = i; distance = gap;}});
      return index;
    }
    go(index, announce) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const left = this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({left, behavior:announce && !this.reduced.matches ? 'smooth' : 'instant'});
      if (announce) this.querySelector('[data-status]').textContent = `${this.cards.indexOf(card) + 1} / ${this.cards.length}`;
      this.update();
    }
    update() {
      if (!this.track) return;
      const index = this.index();
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      this.motion.setAttribute('aria-pressed', String(this.paused));
      this.motion.querySelector('span').textContent = this.paused ? this.dataset.play : this.dataset.pause;
    }
    syncVideos() {
      this.videos.forEach(video => {
        if (this.paused || document.hidden || !video.ccVisible) {video.pause(); return;}
        if (video.dataset.src && !video.getAttribute('src')) {video.src = video.dataset.src; video.load();}
        video.play().catch(() => {});
      });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.videoObserver?.disconnect(); this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame); this.videos?.forEach(video => video.pause());
      this.querySelector('.cc__dots')?.replaceChildren(); this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centric-reviews-option-d"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('centric-reviews-d')) customElements.define('centric-reviews-d',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.abort=new AbortController();
    this.track=this.querySelector('.crd__track');this.cards=[...this.querySelectorAll('[data-card]')].filter(card=>card.getBoundingClientRect().width>0);this.videos=[...this.querySelectorAll('video')];this.previous=this.querySelector('[data-previous]');this.next=this.querySelector('[data-next]');this.motion=this.querySelector('[data-motion]');this.mobile=matchMedia('(max-width:989px)');this.hover=matchMedia('(hover:hover) and (pointer:fine)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.paused=this.dataset.autoplay!=='true'||this.reduced.matches;
    const listen=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});
    this.dots=this.cards.map((card,i)=>{const dot=document.createElement('button');dot.type='button';dot.className='crd__dot';dot.setAttribute('aria-label',`${i+1} / ${this.cards.length}`);listen(dot,'click',()=>this.go(i));this.querySelector('.crd__dots').append(dot);return dot});
    listen(this.previous,'click',()=>this.go(this.index()-1));listen(this.next,'click',()=>this.go(this.index()+1));listen(this.track,'scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update())});
    listen(this.track,'keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.go(this.index()+(e.key==='ArrowRight'?1:-1))}});
    listen(this.motion,'click',()=>{this.paused=!this.paused;this.sync();this.update()});listen(document,'visibilitychange',()=>this.sync());listen(this.mobile,'change',()=>this.sync());listen(this.hover,'change',()=>this.sync());listen(this.reduced,'change',()=>{if(this.reduced.matches)this.paused=true;this.sync();this.update()});
    this.observer=new IntersectionObserver(entries=>{entries.forEach(e=>e.target.crdVisible=e.isIntersecting&&e.intersectionRatio>=.5);this.sync()},{threshold:[0,.5,1]});
    this.videos.forEach(v=>{v.muted=true;v.playsInline=true;const card=v.closest('[data-card]');v.crdTall=card.dataset.videoMode==='tall';v.crdManual=false;this.observer.observe(v);const media=card.querySelector('.crd__media');listen(media,'mouseenter',()=>{v.crdHover=true;this.sync()});listen(media,'mouseleave',()=>{v.crdHover=false;this.sync()});const button=card.querySelector('[data-session]');if(button)listen(button,'click',()=>{v.crdStopped=!v.paused;v.crdManual=v.paused;if(v.paused)this.paused=false;this.sync();this.update()});const progress=card.querySelector('.crd__progress span');if(progress)listen(v,'timeupdate',()=>{progress.style.transform=`scaleX(${v.duration?v.currentTime/v.duration:0})`});listen(v,'play',()=>this.updateSession(v));listen(v,'pause',()=>this.updateSession(v))});
    listen(document,'shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.blockId===e.detail.blockId);if(i>=0)this.go(i)});
    this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.motion.hidden=!this.videos.length;this.update();
  }
  index(){const left=this.track.getBoundingClientRect().left;let index=0,gap=Infinity;this.cards.forEach((c,i)=>{const d=Math.abs(c.getBoundingClientRect().left-left);if(d<gap){index=i;gap=d}});return index}
  go(i){const index=Math.max(0,Math.min(i,this.cards.length-1));const card=this.cards[index];if(!card)return;this.track.scrollTo({left:this.track.scrollLeft+card.getBoundingClientRect().left-this.track.getBoundingClientRect().left,behavior:this.reduced.matches?'instant':'smooth'});this.querySelector('[data-status]').textContent=`${index+1} / ${this.cards.length}`;this.update()}
  update(){const i=this.index();this.previous.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;this.dots.forEach((d,j)=>d.setAttribute('aria-current',String(i===j)));this.motion.setAttribute('aria-pressed',String(this.paused));this.motion.textContent=this.paused?this.dataset.playVideos:this.dataset.pauseVideos}
  updateSession(v){const b=v.closest('[data-card]').querySelector('[data-session]');if(!b)return;v.closest('.crd__media').classList.toggle('is-playing',!v.paused);b.setAttribute('aria-pressed',String(!v.paused));b.querySelector('span').textContent=v.paused?this.dataset.watch:this.dataset.pause;b.querySelector('path').setAttribute('d',v.paused?'M6 4v16l14-8Z':'M5 4h5v16H5ZM14 4h5v16h-5Z')}
  sync(){this.videos.forEach(v=>{const wants=!v.crdStopped;if(this.paused||document.hidden||!v.crdVisible||!wants){v.pause();return}if(v.dataset.src&&!v.getAttribute('src')){v.src=v.dataset.src;v.load()}v.play().catch(()=>{})})}
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();cancelAnimationFrame(this.frame);this.videos?.forEach(v=>v.pause());this.querySelector('.crd__dots')?.replaceChildren();this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centric-rewards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-cr-open]');
  if (opener && window.okeLoyaltyApi && typeof window.okeLoyaltyApi.open === 'function') {
    event.preventDefault();
    window.okeLoyaltyApi.open();
  }
  const how = event.target.closest('[data-cr-how]');
  if (how) {
    const details = how.closest('.cr').querySelector('.cr__how');
    if (details) { event.preventDefault(); details.open = !details.open; }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-fit"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load", function(){
    // const options = {
    //    controlColor: "#000",
    //    controlShadow: true,
    //    fluidMode: false
    // }
  //   const options = {
    
  //     // UI Theme Defaults
    
  //     controlColor: "#000",
  //     controlShadow: true,
  //     addCircle: false,
  //     addCircleBlur: true,
    
  //     // Smoothing
    
  //     smoothing: false,
  //     smoothingAmount: 0,
    
  //     // Other options
    
  //     hoverStart: true,
  //     verticalMode: false,
  //     startingPoint: 50,
  //     fluidMode: false
  //   };
  //   const viewers = document.querySelectorAll(".image-compare");
  //   viewers.forEach((element) => {
  //     let view = new ImageCompare(element, options).mount();
  //   });
  // })
    
  let centimeterBlock = document.querySelector(".centimeter");
  let inchBlock = document.querySelector(".inch");
  let tabsNavs = document.querySelectorAll("ul#tabs-nav li");

  centimeterBlock.style.display = "none";
  tabsNavs.forEach(function(tabsNav){
    tabsNav.addEventListener("click", function(){
      let targetTab = tabsNav.getAttribute("for");
      // console.log({targetTab});
      let sizecontentTabs = document.querySelectorAll(".sizetable-content table");
      sizecontentTabs.forEach(function(sizecontentTab){
          let sizecontentTabTarget = sizecontentTab.getAttribute("class");
          if(sizecontentTabTarget == targetTab){
            sizecontentTab.style.display = "table";
          }else{
            sizecontentTab.style.display = "none";
          }
          // console.log({sizecontentTabTarget});
      })
    })
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
